/** Anything selectable on an axis: verticals, dimensions and metrics all carry a family. */
type FamilyMember = { family_name_clean: string };

/**
 * The family tab a selection panel should open on: the one holding the current
 * selection, so reopening the panel lands on the selected vertical/dimension
 * instead of jumping back to the first tab. A multi-selection (data table
 * dimensions and metrics) opens on its first entry. Falls back to the first
 * available family when nothing is selected, or when the selected family isn't
 * part of the active domain.
 */
export const familyToOpen = (
	selection: FamilyMember | FamilyMember[] | null | undefined,
	availableFamilies: string[]
): string | null => {
	const selected = Array.isArray(selection) ? selection[0] : selection;
	const family = selected?.family_name_clean;

	if (family && availableFamilies.includes(family)) {
		return family;
	}

	return availableFamilies[0] ?? null;
};
